
import { userInfo } from 'os';
import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator'
import EventBus from './../../eventBus'
import UserProVisioning from "@/mixins/userProvisioning"
import RigImport from "@/components/RigImport.vue"

@Component({
    components: {
        "rigs-import": RigImport
    }
})
export default class RigsOverview extends Mixins(UserProVisioning) {
    //Data
    deletePromptProperty: boolean = false
    loader: boolean = true
    loadingTitle: string = 'Loading...'
    loadingMessage: string = 'Loading Rigs'
    successMessage: string = ''
    additionalSuccessMessage = ''
    error: string = ''
    showModal: boolean = false
    selectedRig: any = {
        name: '',
        status: '',
        no_activities: '',
        type: '',
        hp: '',
        depth: '',
        capacity: '',
        description: ''
    }
    activeRig: any = null //under investigation
    search: string = ''
    activeScreen: string = ''
    selectedRows: { name: string; id: string }[] = []
    selectAll: boolean = false

    // Methods
    downloadTemplate() {
        this.$store.dispatch('rigsModule/downloadRigsTemplateAction');
    }

    deleteRigPrompt(selectedRig: any) {
        this.selectedRig.id = selectedRig.id
        this.selectedRig.name = selectedRig.name
        this.selectedRig.no_activities = selectedRig.no_activities
        this.selectedRig.status = selectedRig.status
        this.selectedRig.type = selectedRig.type
        this.selectedRig.hp = selectedRig.hp
        this.selectedRig.depth = selectedRig.depth
        this.selectedRig.capacity = selectedRig.capacity
        this.selectedRig.description = selectedRig.description
        this.deletePromptProperty = true
    }

    editRig(rig_id: number) {
        this.$router.push('/manage-rig/?id=' + rig_id.toString())
    }

    searchValue(e: any) {
        this.search = e
    }

    getRigsToDelete() {
        const rigNames = this.selectedRows.map(row => row.name);

        if (rigNames.length <= 3) {
            const lastTwoNames = this.selectedRows.map(row => row.name).splice(-2);
            return `${rigNames.length === 3 ? `${rigNames[0]},` : ''} ${lastTwoNames.join(' and ')}`
        }
        else {
            const firstTwoNames = rigNames.slice(0, 2);
            const remainingCount = rigNames.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} rig${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDelete(bvEvt: any) {
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = 'Deleting ' + this.selectedRig.name
        this.loadingTitle = 'Deleting'

        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.selectedRig.id]
        const deletedRigs = isMultipleDelete ? this.getRigsToDelete() : '';
        this.deleteRigAction(payload).then((response: any) => {
            this.activeScreen = 'successNoBack'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.successMessage = isMultipleDelete ? `${deletedRigs} Deleted Successfully` : this.selectedRig.name + ' Deleted Successfully'
            this.additionalSuccessMessage = `${isMultipleDelete ? 'These Rigs' : 'This Rig'} will no longer be available`
            this.deletePromptProperty = false
        }, (error: any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
            this.deletePromptProperty = false
        })
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.filteredRigs(this.search).map((rig: any) => ({ id: rig.id, name: rig.name }))
        } else {
            this.selectedRows = []
        }
    }

    // VUEX ACTIONS
    deleteRigAction(payload: string[]) {
        return this.$store.dispatch('rigsModule/deleteRigAction', payload)
    }

    getRigs() {
        return this.$store.dispatch('rigsModule/getRigs')
    }

    get disableDelete() {
        return (rigs: any) => {
            let q = this.filteredSequences('').findIndex((seq: any) => seq.rigs.some((rig: any) => rig.id === rigs.id))
            if (q >= 0) {
                return true
            } else {
                return false
            }
        }
    }

    get currentSystem() {
        return this.$store.getters['UnitsModule/getCurrentUnitSystem']
    }

    fetchSequences() {
        return this.$store.dispatch('sequencesModule/fetchSequences')
    }

    // Computed propertied
    get filteredRigs() {
        return this.$store.getters['rigsModule/filteredRigs']
    }

    get rigs() {
        return this.filteredRigs(this.search).sort((a: any, b: any) => {
            const itemA = (a.name || '').toString().toLowerCase().trim();
            const itemB = (b.name || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }

    get filteredSequences() {
        return this.$store.getters['sequencesModule/filteredRootSequences']
    }

    get fields() {
        if (this.canWriteRig) {
            return [
                { key: 'selectRow', sortable: false },
                { key: 'serial', label: 'S/N', sortable: false },
                { key: 'photo', label: 'Image' },
                { key: 'name', label: 'Rig Name', sortable: 'true' },
                { key: 'owner', label: 'Rig Owner', sortable: 'true' },
                { key: 'minimumHPRating', label: 'Draw Works Rating' },
                // {key: 'rigType', label: 'Rig Type'},
                'terrain', 'actions']
        }

        let fields = [
            { key: 'selectRow', sortable: false },
            { key: 'serial', label: 'S/N', sortable: false },
            { key: 'photo', label: 'Image' },
            { key: 'name', label: 'Rig Name', sortable: 'true' },
            { key: 'owner', label: 'Rig Owner', sortable: 'true' },
            { key: 'minimumHPRating', label: 'Draw Works Rating' },
            // {key: 'rigType', label: 'Rig Type'},
            'terrain']

        if (!this.canWriteSequence) {
            fields.shift()
        }
        return fields
    }

    // CREATED
    created() {
        if (this.filteredRigs('').length === 0) {
            this.getRigs().then(response => {
                this.activeScreen = 'main';
                EventBus.$emit('activeScreen', this.activeScreen)
                this.loader = false
            })
        } else {
            this.activeScreen = 'main';
            EventBus.$emit('activeScreen', this.activeScreen)
            this.loader = false
        }

        if (this.filteredSequences('').length === 0) {
            this.fetchSequences();
        }
    }

}
